import { LOCALES } from 'i18n/locales';

export const creatingObservationSnackBarIntl = {
    [LOCALES.ENGLISH]: {
        'creatingObservation.alert': 'Select a point within the drawn area to create an observation there.',
        'creatingObservation.notification.label': 'Create observation'
    },
    [LOCALES.WELSH]: {
        'creatingObservation.alert': 'Dewiswch bwynt o fewn yr ardal a luniadwyd i greu arsylwad yno.',
        'creatingObservation.notification.label': 'Creu arsylwad'
    }
};
